import { createAction } from '@reduxjs/toolkit';

/* Action Types */
enum ActionTypes {
	SET_SEARCH_TERM = '@@mondriaan/SEARCH_TERM/SET',
}

export const setSearchTerm = createAction<string>(ActionTypes.SET_SEARCH_TERM);
